/* Vorschlagslisten (<datalist>) im Dokument: werden bei Bedarf angelegt und mit neuen Werten gefüllt. */
export function ensureDatalist(id: string, values: Iterable<string>): void {
  let dl = document.getElementById(id) as HTMLDataListElement | null;
  if (!dl) { dl = document.createElement('datalist'); dl.id = id; document.body.append(dl); }
  const want = Array.from(values);
  if (dl.options.length === want.length && want.every((v, i) => dl!.options[i].value === v)) return;
  dl.textContent = '';
  want.forEach((v) => { const o = document.createElement('option'); o.value = v; dl!.append(o); });
}
